export default {
  discounts: (state) => state.discounts,
};
